import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { ActivitySectionDirective, SpecialsService, UserActivityClickTrackingDirective } from '@core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { SwiperContainerComponent } from '@core/lib/components/swiper/swiper-container.component';
import { SwiperSlideComponent } from '@core/lib/components/swiper/swiper-slide.component';
import { RouterLink } from '@angular/router';
import { LoadingComponent } from '@app/components/loading/loading.component';
import { map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { SwiperVideoControlDirective } from '@core/lib/components/swiper/swiper-video-control.directive';

@Component({
  selector: 'app-new-on-tap',
  templateUrl: './new-on-tap.component.html',
  styleUrl: './new-on-tap.component.scss',
  imports: [
    ActivitySectionDirective,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
    SwiperContainerComponent,
    SwiperSlideComponent,
    RouterLink,
    LoadingComponent,
    SwiperVideoControlDirective,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewOnTapComponent {

  private readonly specialsService = inject(SpecialsService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };

  private readonly new$ = this.specialsService.specials$.pipe(
    map((specials) => {
      return specials?.filter(special => {
        return special.name.startsWith('[new-on-tap]');
      });
    }),
  );

  public readonly new = toSignal(this.new$);

  public readonly loading = toSignal(this.specialsService.loading$, {
    initialValue: true,
  });

}
